import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-path-right"} maskId="square-filled-radius-0-stroke-1-IconArrowPathRight"><path d="M13 3.68652V8.00014H2V16.0001H13V20.3138L23.0337 12.0001L13 3.68652Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowPathRight;
